{
  "home": {
    "title": "Организации",
    "add": "Добавить организацию",
    "search": "Поиск",
    "tableLabel": "Таблица организаций",
    "empty": "Организаций нет",
    "emptyHint": "Добавьте первую организацию — затем к ней привязываются водохранилища и админы.",
    "noResults": "Ничего не найдено",
    "clear": "Очистить",
    "loadError": "Не удалось загрузить данные",
    "retry": "Повторить"
  },
  "columns": {
    "organization": "Организация",
    "slug": "Идентификатор",
    "tenants": "Водохранилища",
    "createdAt": "Создана",
    "actions": "Действие",
    "reservoir": "Водохранилище",
    "kind": "Тип",
    "location": "Расположение",
    "siteId": "ID единого сервера",
    "members": "Сотрудники",
    "admin": "Админ",
    "login": "Логин",
    "position": "Должность",
    "phone": "Телефон"
  },
  "actions": {
    "open": "Открыть",
    "edit": "Редактировать",
    "delete": "Удалить",
    "addAdmin": "Добавить админа",
    "openReservoir": "Перейти к водохранилищу",
    "remove": "Убрать",
    "rowMenu": "Действия",
    "editOrganization": "Редактировать организацию"
  },
  "org": {
    "subtabs": "Разделы организации",
    "tenantsTab": "Водохранилища",
    "adminsTab": "Админы организации",
    "addTenant": "Добавить водохранилище",
    "addAdmin": "Добавить админа",
    "tenantsLabel": "Таблица водохранилищ",
    "adminsLabel": "Таблица админов организации",
    "noTenants": "Водохранилищ нет",
    "noTenantsHint": "Добавьте первое водохранилище организации.",
    "noAdmins": "Админов нет",
    "noAdminsHint": "Добавьте админа организации — он управляет всеми водохранилищами.",
    "notFound": "Организация не найдена",
    "notFoundHint": "Организация удалена или у вас нет к ней доступа.",
    "you": "Вы"
  },
  "kinds": {
    "reservoir": "Водохранилище",
    "hydro_plant": "ГЭС",
    "canal": "Канал",
    "pump_station": "Насосная станция",
    "other": "Другое"
  },
  "orgPanel": {
    "createTitle": "Добавить организацию",
    "name": "Название",
    "namePlaceholder": "Например: Узбекгидроэнерго",
    "slug": "Идентификатор",
    "slugHint": "Используется в адресе: только строчные латинские буквы, цифры и \"-\"",
    "slugLocked": "Идентификатор может изменить только главный админ",
    "description": "Описание",
    "descriptionPlaceholder": "Коротко об организации",
    "danger": "Опасная зона",
    "delete": "Удалить организацию",
    "deleteHint": "Организация и все её водохранилища будут удалены.",
    "confirmDelete": {
      "title": "Удалить организацию",
      "text": "«{{name}}» и её водохранилища ({{count}}) будут удалены. Это действие нельзя отменить.",
      "confirm": "Удалить"
    }
  },
  "tenantPanel": {
    "createTitle": "Добавить водохранилище",
    "name": "Название",
    "namePlaceholder": "Например: Чарвакское водохранилище",
    "slug": "Идентификатор",
    "slugHint": "Используется в адресе: /t/идентификатор",
    "kind": "Тип",
    "description": "Описание",
    "descriptionPlaceholder": "Коротко об объекте",
    "location": "Расположение",
    "lat": "Широта",
    "lng": "Долгота",
    "latPlaceholder": "41.6512",
    "lngPlaceholder": "70.0261",
    "siteId": "ID сайта единого сервера",
    "siteIdPlaceholder": "Например: chotqol-01",
    "siteIdHint": "Идентификатор объекта на едином сервере ATNT (для живых данных)",
    "admins": "Админы",
    "noAdmins": "Админ ещё не назначен",
    "addAdmin": "Добавить админа",
    "removeAdmin": "{{name}} — убрать",
    "danger": "Опасная зона",
    "delete": "Удалить водохранилище",
    "deleteHint": "Водохранилище, его страницы и устройства будут удалены.",
    "confirmDelete": {
      "title": "Удалить водохранилище",
      "text": "«{{name}}» будет удалено. Это действие нельзя отменить.",
      "confirm": "Удалить"
    },
    "confirmRemoveAdmin": {
      "title": "Убрать админа",
      "text": "«{{name}}» будет убран из водохранилища «{{tenant}}».",
      "confirm": "Убрать"
    }
  },
  "adminPanel": {
    "orgTitle": "Добавить админа организации",
    "tenantTitle": "Добавить админа водохранилища",
    "orgCaption": "Организация: {{name}}",
    "tenantCaption": "Водохранилище: {{name}}",
    "orgNote": "Админ организации управляет всеми водохранилищами организации и их админами.",
    "tenantNote": "Админ водохранилища имеет полный доступ ко всем разделам этого водохранилища.",
    "confirmRemove": {
      "title": "Убрать админа",
      "text": "«{{name}}» будет убран из админов организации.",
      "confirm": "Убрать"
    }
  },
  "form": {
    "fullName": "Ф.И.О.",
    "fullNamePlaceholder": "Имя Фамилия",
    "position": "Должность",
    "positionPlaceholder": "Например: Главный диспетчер",
    "phone": "Телефон",
    "phonePlaceholder": "+998 90 123 45 67",
    "active": "Активен",
    "save": "Сохранить",
    "cancel": "Отмена",
    "backLink": "Вернуться назад"
  },
  "validation": {
    "required": "Заполните пустое поле",
    "min": "Введите не менее {{count}} символов",
    "max": "Не более {{count}} символов",
    "slug": "Только строчные латинские буквы, цифры и \"-\"",
    "lat": "Широта должна быть от -90 до 90",
    "lng": "Долгота должна быть от -180 до 180",
    "login": "Только латинские буквы, цифры и . _ -",
    "phone": "Неверный номер телефона"
  },
  "toast": {
    "orgCreated": "Организация добавлена",
    "orgSaved": "Организация сохранена",
    "orgDeleted": "Организация удалена",
    "tenantCreated": "Водохранилище добавлено",
    "tenantSaved": "Водохранилище сохранено",
    "tenantDeleted": "Водохранилище удалено",
    "adminCreated": "Админ добавлен",
    "adminRemoved": "Админ убран",
    "noChanges": "Изменений нет",
    "error": "Произошла ошибка"
  }
}
